import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { ApiService, ServicePaymentRecordDTO, PaymentRecordDTO, Service, BankingService, VOCType, ServiceUpdateRequestDTO, PaymentRequestQueryType } from "../../../../../projects/accounting/src/public_api";
import { DatePipe, DecimalPipe } from "@angular/common";
import { MassTransferEditorComponent } from "./mass-transfer-editor/mass-transfer-editor.component";
import { PaymentEditorComponent, PaymentEditorType } from '../../popups/payment-editor/payment-editor.component';
import { VOCEditorComponent } from '../../popups/voc-editor/voc-editor.component';
import { CachingService } from '../../../../../projects/jv-common/src/lib/services/caching.service';
import { MessageBoxComponent, MessageBoxData } from '../../../../../projects/jv-ui/src/public_api';
import { MassTransferResolverComponent } from './mass-transfer-resolver/mass-transfer-resolver.component';

@Component({
  selector: 'app-debts-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {

  modalRef: BsModalRef;

  constructor(
    private modal: BsModalService,
    private api: ApiService,
    private cache: CachingService,
    private decimal: DecimalPipe,
    private date: DatePipe,
    private banking: BankingService) {
  }

  public dtConfig = null;
  public loading = false;
  period = null;
  currentPeriod = null;
  nextPeriod = null;
  private SERVICE_ACCOUNTS_CACHE_KEY: string = "service-accounts";
  private SERVICE_PAYMENT_HISTORY_CACHE_KEY: string = "service-payment-history";

  subs: any = {};
  history: any = {};

  private generate(data: Array<Service>, period) {
    return {
      data: data,

      group: i => {

        let parts = i.info.address.split(',');

        if (parts.length != 3) parts[parts.length - 1] = 'KHÁC';

        return { parent: "TẤT CẢ", html: parts[parts.length - 1].trim() }
      },

      txt: i => [i.info.name, i.info.address, i.accounts[0].owner, i.info.phone, i.accounts[0].account, i.accounts[0].globalBankName].join(' '),

      title: 'THANH TOÁN DỊCH VỤ THÁNG ' + period,
      columns: [
        {
          title: 'Dịch vụ',
          html: function (i) {
            return '<b>' + i.info.name + '</b>';
          },
        },
        {
          title: 'Liên hệ',
          html: i => {
            let html = '';

            html += i.info.phone != '' ? '<div class="text-primary"><i class="fa-phone fa"></i>' + i.info.phone + '</div>' : '';
            html += i.info.email != '' ? '<div class="text-primary"><i class="fa fa-envelope"></i>' + i.info.email + '</div>' : '';

            i.accounts.forEach(account => {

              let validation = this.banking.validate(account);
              html += '<div class="' + (validation.valid ? (validation.transferable ? 'text-success' : '') : 'text-danger') + '"><sub><i class="' + (validation.valid ? (validation.transferable ? 'fa fa-bank' : 'fas fa-dollar-sign') : 'fa fa-exclamation-circle') + '"></i>' + (validation.valid ? account.globalBankName + ' (' + account.name + ')' : (account.name == '' ? 'Lỗi tài khoản phụ chưa đặt tên' : 'Lỗi ' + account.name)) + '</sub></div>';
            });

            return html;
          },
          css: i => 'custom-info text-uppercase',
          click: i => this.edit(i)
        },
        {
          title: 'Đã thanh toán',
          class: 'text-right',
          html: i => '<b>' + this.decimal.transform(i.paid, '1.0-0', 'en-US') + '<br><small><i class="text-danger">Ghi nhận chi</i></small>',
          css: i => 'text-right text-danger',
          click: i => this.pay(i)
        }
      ],

      footer: data => {
        let paid = 0;
        data.forEach(i => {
          paid += i.paid;
        });
        return [
          { html: '<b>TỔNG</b>' },
          { html: '' },
          {
            html: '<b>' + this.decimal.transform(paid, '1.0-0', 'en-US') + '</b>',
            class: 'text-right text-danger',
          },
        ];
      }
    }
  }

  private async asyncMount() {

    let accounts = {};
    let history = {};

    await this.cache.get(this.SERVICE_ACCOUNTS_CACHE_KEY, {})
      .toPromise()
      .then(data => accounts = data);

    await this.cache.get(this.SERVICE_PAYMENT_HISTORY_CACHE_KEY, {})
      .toPromise()
      .then(data => history = data);


    return Promise.resolve({ accounts: accounts, history: history });
  }

  private async asyncLoad(period) {

    let data: Array<ServicePaymentRecordDTO>;

    await this.api.paidToServices({ Period: period, Type: PaymentRequestQueryType.forPeriod })
      .toPromise()
      .then(response => data = response.succeed ? response.data : []);

    return Promise.resolve({ data: data });
  }

  private async asyncUpdate(data: Service) {

    let info, accounts;

    let request: ServiceUpdateRequestDTO = {
      ID: data.info.id,
      Phone: data.info.phone,
      Email: data.info.email,
    };

    await this.api.updateService(request).toPromise().then(response => info = response.succeed && response.data);

    let key = '#' + data.info.id;

    let jsonObj = {};
    for (let o in this.subs) jsonObj[o] = this.subs[o];
    jsonObj[key] = data.accounts;

    await this.cache.set(this.SERVICE_ACCOUNTS_CACHE_KEY, jsonObj).toPromise().then(response => accounts = response);

    return Promise.resolve({ info: info, accounts: accounts });
  }

  ngOnInit() {

    let anchor = new Date();

    this.nextPeriod = this.date.transform(anchor, "MM-yyyy");

    anchor.setMonth(anchor.getMonth() - 1)

    this.currentPeriod = this.date.transform(anchor, "MM-yyyy");

    this.asyncMount()
      .then(rs => {

        this.history = rs.history;
        this.subs = rs.accounts;

        if (this.dtConfig != null) {
          this.dtConfig.data.forEach(i => {

            let key = "#" + i.info.id;

            if (typeof this.subs[key] == "undefined") {
              this.subs[key] = [{
                name: 'THÔNG TIN CHÍNH',
                account: '',
                owner: '',
                globalBankName: '',
                globalBranchName: ''
              }];
            }

            i.accounts = this.subs[key];
          });
        }
      });
  }

  // load debts to vendors in a specified period
  load(period) {

    this.loading = true;

    this.asyncLoad(period)
      .then(response => {

        console.log(response);

        this.loading = false;

        let data: Array<Service> = [];

        response.data.forEach(i => {

          let obj: Service = {
            info: {
              id: i.ID,
              name: i.Name,
              address: i.Address,
              type: VOCType.vendor,
              phone: i.Phone,
              email: i.Email
            },

            accounts: [],
            paid: 0
          };


          i.Payments.forEach(p => obj.paid += p.Amount);

          let key = '#' + obj.info.id;

          if (typeof this.subs[key] != 'undefined') {
            this.subs[key].forEach(account => obj.accounts.push(account));
          }
          else {
            obj.accounts.push({
              name: 'THÔNG TIN CHÍNH',
              account: '',
              globalBankName: '',
              globalBranchName: '',
              owner: ''
            });
          }

          data.push(obj);
        });

        this.period = period;
        this.dtConfig = this.generate(data, period);
      });
  }

  // acknowledge a payment to a vendor
  pay(service: Service) {

    this.modalRef = this.modal.show(PaymentEditorComponent, {
      class: 'modal-md',
      initialState: {
        data: {
          name: service.info.name,
          address: service.info.address,
          type: PaymentEditorType.expense,
          accounts: this.banking.sources,
          account: typeof this.history["#" + service.info.id] == "undefined" ? null : this.history["#" + service.info.id],
          amount: 0
        }
      }
    }).content.commit.subscribe(data => {

      if (typeof this.history["#" + service.info.id] == "undefined" || this.history["#" + service.info.id] != data.account) {
        this.history["#" + service.info.id] = data.account;

        this.cache.set(this.SERVICE_PAYMENT_HISTORY_CACHE_KEY, this.history).subscribe(succeed => { });
      }

      let request = {
        ID: service.info.id,
        Amount: data.amount,
        Bank: data.account,
        Period: this.period,
        Date: data.date
      };

      this.loading = true;

      this.api.payToService(request).subscribe(
        response => {

          this.loading = false;
          if (response.succeed && response.data) {

            service.paid += data.amount;
          }
          else {
            this.error("Không tạo được ghi nhận chi");
          }

        },
        error => {
          this.loading = false;
          this.error("Không tạo được ghi nhận chi");
        }
      );
    });
  }

  error(message: string) {

    let data: MessageBoxData = {
      title: "LỖI",
      content: '<div class="text-danger text-center">' + message + '</div>',
      buttons: [{ name: "OK", class: "bg-danger" }],
      closable: true,
      header: true
    };

    this.modal.show(MessageBoxComponent, {
      class: 'modal-md', initialState: {
        data: data
      }
    });
  }

  // edit service information
  edit(service: Service) {

    this.modal.show(VOCEditorComponent, {
      class: 'modal-lg',
      initialState: {
        data: {
          info: service.info,
          accounts: service.accounts,
        }
      }
    }).content.change
      .subscribe(data => {

        this.asyncUpdate(data).then(rs => {

          if (rs.info) service.info = data.info;

          if (rs.accounts) {
            service.accounts = data.accounts;

            let key = '#' + service.info.id;
            this.subs[key] = data.accounts;
          }
        });
      });
  }

  export() {
    this.modal.show(MassTransferEditorComponent, {
      class: 'modal-lgg',
      initialState: {
        data: {
          records: this.dtConfig.data,
          period: this.period
        }
      }
    })
  }

  confirm() {
    this.modal.show(MassTransferResolverComponent, {
      class: 'modal-lgg'
    }).content.closed.subscribe(changed => {
      if(changed) this.load(this.period);
    });
  }
}
